import { render, staticRenderFns } from "./MediaManagementMobile.vue?vue&type=template&id=fb390678&scoped=true&"
import script from "./MediaManagementMobile.vue?vue&type=script&lang=js&"
export * from "./MediaManagementMobile.vue?vue&type=script&lang=js&"
import style0 from "./MediaManagementMobile.vue?vue&type=style&index=0&id=fb390678&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb390678",
  null
  
)

export default component.exports